import React from 'react'
import './experience.css'
import { BsPatchCheckFill} from 'react-icons/bs'

const Experience = () => {
  return (
    // <div>Experience</div>
    <section id='experience'>
      <h5> The Skills I Have</h5>
      <h2>My Experience</h2>

      <div className="container experience__container">
        <div className="experience__frontend">
          <h3> FrontEnd Development</h3>
          <div className='experience__content'>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>HTML</h4>
                <small className='text-light'>Experienced </small>
              </div>

            </article>

            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>CSS</h4>
                <small className='text-light'>Intermediate </small>
              </div>

            </article>

            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>JavaScript</h4>
                <small className='text-light'>Intermediate </small>
              </div>

            </article>

            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>React</h4>
                <small className='text-light'>Intermediate </small>
              </div>

            </article>

            {/* <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon'/>
              <h4>TyoeScript</h4>
              <small className='text-light'>Beginner </small>
            </article> */}
          </div>
        </div>

        <div className="experience__mobile">
          <h3> Mobile Development</h3>
          <div className='experience__content'>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Flutter</h4>
                <small className='text-light'>Experienced </small>
              </div>

            </article>

            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Dart</h4>
                <small className='text-light'>Experienced </small>
              </div>

            </article>

            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Firebase</h4>
                <small className='text-light'>Intermediate </small>
              </div>
            </article>

            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Java</h4>
                <small className='text-light'>Intermediate </small>
              </div>

            </article>

            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Kotlin</h4>
                <small className='text-light'>Basic </small>
              </div>

            </article>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Experience